/*
 * @Descripttion:
 * @version: 0.0.1
 * @Author: gavin chan
 * @Date: 2020-05-11 10:34:03
 * @LastEditors: gavin chan
 * @LastEditTime: 2020-08-20 16:53:38
 * @Notes:
 */
import axios, { Method } from "axios";
import * as QS from "qs";
// import Flatted from "flatted";
// import toast from "../widget/toast";
// import loading from "../widget/loading";
// import { requestCommonParams } from "./helper";
// import { loginout } from "utils/cookieHelper";
// const target = process.env.BUILD_TARGET;

interface AxiosOptions {
  url: string;
  method?: Method;
  data?: any;
}

export default function $axios({ url, method = "get", data }: AxiosOptions) {
  const config = {
    // 基础url前缀
    // baseURL: API_URL,
    // todo 需要动态化
    // url: "folder/list",
    // url: url,
    // baseURL: 'https://devline.cattrip.net/',
    // 请求头信息
    // headers: {
    // 	'Content-Type': 'application/json;charset=UTF-8',
    // },
    // 设置超时时间
    timeout: 10000,
    // data: data,
    // todo 鉴权
    // auth: {
    //   username: "janedoe",
    //   password: "s00pers3cret",
    // },
    // 携带凭证
    withCredentials: true,
    // 返回数据类型
    // responseType: 'json',
    // paramsSerializer: (params: any) => {
    // 	return qs.stringify(params, { arrayFormat: 'brackets' })
    // },
    // `transformResponse` allows changes to the response data to be made before
    // it is passed to then/catch
    // transformResponse: [
    //   function (data: any) {
    //     // Do whatever you want to transform the data

    //     return data;
    //   },
    // ],
    validateStatus: function (status: number) {
      return status === 200;
    },
  };
  return new Promise((resolve, reject) => {
    const instance = axios.create(config);

    // request 拦截器
    instance.interceptors.request.use(
      (Config: any) => {
        // if (target === "client") {
        //   loading.open();
        // }
        // 1. 请求开始的时候可以结合 rematch 开启全屏 loading 动画
        // if (Config.method === 'post') {
        // 	Config.data = qs.stringify(options.params)
        // }
        // config.data = qs.stringify(config.data);
        // debugger;
        // 2. 根据请求方法，序列化传来的参数
        if (method === "post") {
          // 设置header
          // Config.headers = {
          //   // "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
          //   "Content-Type": "application/json",
          // };
          Object.assign(Config, {
            headers: { "Content-Type": "application/json;charset=utf-8" },
          });
          // Config.data = { ...Config.data, ...common }
          // 参数序列化
          // let commonParams = Flatted.parse(
          //   Flatted.stringify(requestCommonParams())
          // );
          // const returnedTarget = Object.assign({}, commonParams, Config.data);
          // const returnedTarget = Object.assign({}, Config.data);
          // Config.data = QS.stringify(returnedTarget);
          // }
        } else {
          // 设置header
          Config.headers = {
            // 'Accept': 'application/json',
            "Content-Type": "text/plain;charset=utf-8",
          };
          // 参数序列化
          // let commonParams = requestCommonParams();
          // const returnedTarget = Object.assign({}, commonParams, Config.data);
          const returnedTarget = Object.assign({}, Config.data);
          Config.data = QS.stringify(returnedTarget);
          Config.url = Config.url + "?" + Config.data;
        }
        // console.log(Config);
        return Config;
      },
      (error: any) => {
        // 请求错误时
        console.log("请求前", error);
        console.log("request:", error);
        // 1. 判断请求超时
        // todo 请求超时处理
        if (
          error.code === "ECONNABORTED" &&
          error.message.indexOf("timeout") !== -1
        ) {
          console.log("timeout请求超时");
          // return service.request(originalRequest);//再重复请求一次
        }
        // 2. 需要重定向到错误页面
        // const errorInfo = error.response;
        // if (errorInfo) {
        //   //error = errorInfo.data  //页面那边catch的时候就能拿到详细的错误信息,看最下边的Promise.reject
        //   const errorStatus = errorInfo.status; // 404 403 500 ...
        //   router.push({
        //     path: `/error/${errorStatus}`
        //   });
        // }
        return Promise.reject(error); // 在调用的那边可以拿到(catch)你想返回的错误信息
      }
    );

    // response 拦截器
    instance.interceptors.response.use(
      (response: any) => {
        // if (target === "client") {
        //   loading.close();
        // }
        console.log("请求结果", response);
        let res;
        // IE9时response.data是undefined，因此需要使用response.request.responseText(Stringify后的字符串)
        if (response.data === undefined) {
          res = JSON.parse(response.request.responseText);
        } else {
          res = response.data;
        }
        // 根据返回的code值来做不同的处理
        switch (res.code) {
          // 请求成功
          case "0000":
            // return res.data
            return res;
          case "1000":
            return res.data;
          // todo
          case "2003":
            // return res.data
            // toast.open("Login expired");
            // loginout();
            // setTimeout(() => {
            //   window.location.href = "/login";
            // }, 2000);
            return res;
          // todo
          case "2000":
            // toast.open("Login expired");
            // setTimeout(() => {
            //   window.location.href = "/login";
            // }, 2000);
            // history.push('/login')
            // store.dispatch(push('/login'))
            // throw Error("登录已过期");
            return res;
          default:
            return res;
        }
      },
      (err: any) => {
        if (err && err.response) {
          console.log("请求后", err);
          switch (err.response.status) {
            case 400:
              err.message = "请求错误";
              break;

            case 401:
              err.message = "未授权，请登录";
              break;

            case 403:
              err.message = "拒绝访问";
              break;

            case 404:
              err.message = `请求地址出错: ${err.response.config.url}`;
              break;

            case 408:
              err.message = "请求超时";
              break;

            case 500:
              err.message = "服务器内部错误";
              break;

            case 501:
              err.message = "服务未实现";
              break;

            case 502:
              err.message = "网关错误";
              break;

            case 503:
              err.message = "服务不可用";
              break;

            case 504:
              err.message = "网关超时";
              break;

            case 505:
              err.message = "HTTP版本不受支持";
              break;

            default:
          }
        }
        console.error(err);
        return Promise.reject(err); // 返回接口返回的错误信息
      }
    );

    // 请求处理
    instance(url, { method, data })
      .then((res: any) => {
        resolve(res);
        return false;
      })
      .catch((error: any) => {
        reject(error);
      });
  });
}
